/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

// Material UI table
import { MaterialReactTable } from "material-react-table";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import CompanyDetailsCommonHeader from "../../CompanyDetailsCommonHeader/CompanyDetailsCommonHeader";
import CompanyTeamMembersHeader from "../CompanyTeamMembersHeader/CompanyTeamMembersHeader";
import AddLabelModal from "components/Common/Modal/AddLabelModal";
import MemberDetailsModal from "../Modals/MemberDetailsModal";
import { assetImages } from "constants";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import { createContactChatHandler } from "helper/AppUserHelper/AppUserHelper";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";

const CompanyTeamMembersBody = () => {
  const { t, i18n } = useTranslation(); //for translation

  const params = useParams();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const moduleAccess = localStorage.getItem("moduleaccess");

  const [isLoading, setIsLoading] = useState(false);
  const [companyMemberList, setCompanyMemberList] = useState([]);
  const [memberStatus, setMemberStatus] = useState({});
  const [isCompanyModerator, setIsCompanyModerator] = useState(false);
  const [isDataReady, setIsDataReady] = useState(false);

  //optionally, you can manage the row selection state yourself
  const [rowSelection, setRowSelection] = useState({});
  const [selectedCompanyMemberIds, setSelectedCompanyMemberIds] = useState([]);
  const [selectedMemberId, setSelectedMemberId] = useState(null);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const getCompanyDetails = async () => {
    try {
      setIsLoading(true);
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_COMPANY_DETAILS}/${params.id}?modulefrom=backend`;
      const response = await getData(requestUrl);

      console.log("response of company details------>", response);

      if (response.status && response.data) {
        let isModerator = false;
        if (
          response.data.moderator.toString() === userInfo._id.toString() ||
          userInfo.role.slug === "ADMIN" ||
          userInfo.role.slug === "SUPER_ADMIN"
        ) {
          isModerator = true;
        } else {
          getMemberDetails();
        }

        setIsCompanyModerator(isModerator);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  //function for get details of company member
  const getMemberDetails = async () => {
    try {
      const apiUrl = `${url.API_BASE_URL}${url.API_GET_COMPANY_MEMBER_DETAILS_BY_QUERY}?companyid=${params.id}`;
      const response = await getData(apiUrl);
      // console.log("response in member details", response);
      if (response.status) {
        setMemberStatus({
          id: response.data._id,
          status: response.data.memberstatus,
          modStatus: response.data.moderatorstatus,
          inviteDate: response.data.requestdate,
          joinDate: response.data.joindate,
        });
      }
    } catch (error) {
      console.error("Error fetching member details:", error);
    }
  };

  //function for get all contacts
  const getAllCompanyMemberList = async () => {
    setRowSelection({});
    setSelectedCompanyMemberIds([]);
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_COMPANY_MEMBERS +
        `?company=${params.id}`;

      // if (filterName != "") {
      //   requestUrl = requestUrl + `&filtername=${filterName}`;
      // }

      // if (filterEmail != "") {
      //   requestUrl = requestUrl + `&filteremail=${filterEmail}`;
      // }

      // if (filterPhone != "") {
      //   requestUrl = requestUrl + `&filterphone=${filterPhone}`;
      // }

      // if (filterPostion != "") {
      //   requestUrl = requestUrl + `&filterposition=${filterPostion}`;
      // }

      // if (filterLabels.length > 0) {
      //   requestUrl = requestUrl + `&filterlabels=${filterLabels}`;
      // }

      console.log("url of company member list------>", requestUrl);

      const response = await getData(requestUrl);

      console.log("response in company member list------>", response);

      setIsLoading(false);
      if (response.status) {
        setCompanyMemberList(response.data);
        // resetFilterData();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for change status
  const deleteBulkMemberHandler = async () => {
    if (selectedCompanyMemberIds.length > 0) {
      try {
        const memberListToBeDelete = companyMemberList.filter((item) =>
          selectedCompanyMemberIds.includes(item._id)
        );

        let apiData = {
          company: params.id,
          companymemberlist: memberListToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL +
          url.API_DELETE_BULK_COMPANY_MEMBER +
          ``;

        const response = await putData(requestURL, apiData);

        // console.log("response in delete bulk member------>", response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            getAllCompanyMemberList();
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setMessageType("error");
      setAlertMessage("Please select member for delete");
    }
    setShowAlert(true);
  };

  //material table columns array
  const initialTableColumns = [
    {
      accessorKey: "#",
      header: t("Actions"),
      size: 50,
      Cell: ({ row }) => {
        if (row.original.rolestring === "Moderator") {
          return (
            <button className="action_btn_mui">
              <span className="d-block material-symbols-outlined horz_icon">
                more_horiz
              </span>
            </button>
          );
        } else {
          return (
            <button
              className="action_btn_mui"
              data-bs-toggle="modal"
              data-bs-target="#addCompanyMember"
              aria-controls="addCompanyMember"
              onClick={() => {
                setSelectedMemberId(row.original._id);
              }}
            >
              <span className="d-block material-symbols-outlined horz_icon">
                more_horiz
              </span>
            </button>
          );
        }
      },
      enableColumnActions: false, // Hides the column action icon
      enableColumnDragging: false, // Hides the move icon
      enableSorting: false,
    },
    {
      accessorKey: "name",
      header: "Name",
      size: 200,
      Cell: ({ row }) => (
        <div className="name border-bottom-0">
          <div className="d-flex gap-4">
            <div className="profile d-flex align-items-center gap-2">
              <div
                className="avatar rounded-circle overflow-hidden"
                style={{ width: "35px", height: "35px" }}
              >
                <img
                  src={
                    row.original.image !== ""
                      ? url.SERVER_URL + row.original.image
                      : assetImages.defaultUser
                  }
                  alt="Richard Hawail"
                  className="w-100 h-100 object-fit-cover object-center"
                />
              </div>
              <div>
                <p className="fs-md fw-semibold mb-0">{row.original.name}</p>
                <Link
                  to="mailto:richard.hawail@gmail.com"
                  className="d-block lh-1"
                >
                  {row.original.email}
                </Link>
              </div>
            </div>
            <button
              onClick={() => {
                createContactChatHandler(row.original.user);
              }}
              className={
                row.original.user?.toString() === userInfo._id.toString()
                  ? "d-none"
                  : "d-flex align-items-center ms-auto border-0 bg-light"
              }
            >
              <span className="d-block material-symbols-outlined icon-md text-primary">
                chat
              </span>
            </button>
          </div>
        </div>
      ),
    },
    {
      accessorKey: "tagstring",
      header: "Label",
      size: 200,
      Cell: ({ row }) => (
        <div className="label border-bottom-0">
          {row.original.tagstring != "" && (
            <ul className="d-flex flex-wrap gap-2 fs-xs">
              {row.original.tagstring.split(" , ").map((tag, index) => {
                return (
                  <li
                    key={index}
                    className="px-2 py-1 gradient-light rounded-5"
                  >
                    {tag}
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      ),
    },
    {
      accessorKey: "rolestring",
      header: "Role",
      size: 150,
      Cell: ({ row }) => (
        <div className="role border-bottom-0">
          <p className="fw-semibold">{row.original.rolestring}</p>
        </div>
      ),
    },
    {
      accessorKey: "status",
      header: "Status",
      size: 150,
      Cell: ({ row }) => (
        <div className="status border-bottom-0">
          <ul className="d-flex flex-column flex-wrap gap-1">
            {row.original.moderatorstatus == "" ? (
              <li className="d-flex align-items-center gap-1">
                <span className="d-block fw-semibold"></span>
              </li>
            ) : (
              <li className="d-flex align-items-center gap-1">
                <span
                  className={`d-block material-symbols-outlined icon-fill icon-lg  ${
                    row.original.moderatorstatus == "1"
                      ? "text-success"
                      : row.original.moderatorstatus == "0"
                      ? "text-primary"
                      : "text-gray"
                  }`}
                >
                  check_circle
                </span>
                <span className="d-block fw-semibold">Moderator</span>
              </li>
            )}
            {/* {row.original.memberstatus == "" ? (
              <li className="d-flex align-items-center gap-1">
                <span className="d-block fw-semibold">--</span>
              </li>
            ) : (
              <li className="d-flex align-items-center gap-1">
                <span
                  className={`d-block material-symbols-outlined icon-fill icon-lg  ${
                    row.original.memberstatus == "1"
                      ? "text-success"
                      : row.original.memberstatus == "0"
                      ? "text-gray"
                      : "text-warning"
                  }`}
                >
                  check_circle
                </span>
                <span className="d-block fw-semibold">Member</span>
              </li>
            )} */}
          </ul>
        </div>
      ),
    },
    {
      accessorKey: "requestdate",
      header: "Date",
      size: 150,
    },
  ];

  //* Material React Table Column and States */
  const columns = useMemo(() => initialTableColumns, [i18n.language]);

  //initialize the column order
  const initialColumnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key] && key !== "0"
    );

    if (selectedIdsArray.length > 0) {
      setSelectedCompanyMemberIds(selectedIdsArray);
    } else {
      setSelectedCompanyMemberIds([]);
    }
  }, [rowSelection]);

  useEffect(() => {
    if (params.id) {
      const initializeData = async () => {
        await getCompanyDetails();
        await getAllCompanyMemberList();
        await getMemberDetails();
        setIsDataReady(true);
      };
      initializeData();
    }
  }, [params.id]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_COMPANY")
  ) {
    return (
      <div id="content_wrapper">
        <section className="event-details-wrapper bg-white pb-5">
          {/* ---- companies common header ---- */}
          {params.id && <CompanyDetailsCommonHeader moduleName="teammembers" />}
          <div className="container-fluid px-lg-5 pt-4 pt-md-0">
            {/* ------- filter area --------- */}
            <CompanyTeamMembersHeader
              reloadCompanyMemberList={getAllCompanyMemberList}
              isCompanyModerator={isCompanyModerator}
            />

            {/* ------- list area ---------- */}

            {!isDataReady || isLoading ? (
              <div className="placeholder-glow d-flex flex-column gap-4">
                <span className="placeholder placeholder-lg bg-secondary col-12"></span>
                <span className="placeholder placeholder-lg bg-secondary col-8"></span>
                <span className="placeholder placeholder-lg bg-secondary col-4"></span>
              </div>
            ) : isCompanyModerator ? (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns} // map columns to be displayed with api data,
                  data={companyMemberList} // data from api to be displayed
                  enableGrouping
                  enableRowSelection // enable showing checkbox
                  getRowId={(row) => row._id} // map which value to select with row checkbox
                  onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                  state={{ rowSelection, columnOrder: initialColumnOrder }} //pass our managed row selection state to the table to use
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50, //make columns wider by default
                  }}
                  enableStickyHeader
                />
              </div>
            ) : (
              <div className="table-wrapper">
                {memberStatus.status === "1" ? (
                  <div className="project-members-container mb-4">
                    <h4 className="fs-sm mb-2 fw-semibold">
                      {t("Team Members")}
                    </h4>
                    <div className="row">
                      {companyMemberList.map((member, index) => {
                        return (
                          <div className="col-lg-3 col-sm-6 mb-2" key={index}>
                            <div className="member-box p-3 rounded-5 bg-white d-flex gap-2 align-items-center">
                              <div className="members-pic d-flex align-items-center justify-content-center overflow-hidden body-bg rounded-circle">
                                <img
                                  src={
                                    member.image === ""
                                      ? assetImages.defaultUser
                                      : url.SERVER_URL + member.image
                                  }
                                  alt=""
                                  className="h-100 w-100 object-fit-cover"
                                />
                              </div>
                              <div className="members-info">
                                <h3 className="fs-lg fw-semibold text-black mb-0">
                                  {member.name}{" "}
                                </h3>
                                <h5 className="fs-sm mb-0 text-black">
                                  {member.rolestring}
                                </h5>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : isLoading ? null : (
                  <AccessDeniedView />
                )}
              </div>
            )}
          </div>
        </section>

        {/* ---------- popups and modals area --------- */}
        {/* --------- add label modal ------------ */}
        <AddLabelModal
          moduleName="companymember"
          selectedIds={selectedCompanyMemberIds}
          afterTagModalClose={getAllCompanyMemberList}
        />

        {/* ---------- member details modal ----------- */}
        <MemberDetailsModal
          afterModalClose={getAllCompanyMemberList}
          selectedMemberId={selectedMemberId}
          setSelectedMemberId={setSelectedMemberId}
        />

        <DeleteWarningModal
          onCancelDelete={() => {
            setRowSelection({});
            setSelectedCompanyMemberIds([]);
          }}
          onDelete={deleteBulkMemberHandler}
          moduleName={t("member")}
        />

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default CompanyTeamMembersBody;
